document.addEventListener('DOMContentLoaded', () => {
  const mobileMq = window.matchMedia('(max-width: 767px)');

  document.querySelectorAll('[data-media-archive-tags]').forEach((root) => {
    const trigger = root.querySelector('[data-media-archive-tags-trigger]');
    const panel = root.querySelector('[data-media-archive-tags-panel]');
    const search = root.querySelector('[data-media-archive-tags-search]');
    const closeBtn = root.querySelector('[data-media-archive-tags-close]');
    const options = root.querySelectorAll('[data-media-archive-tags-option]');

    if (!trigger || !panel) {
      return;
    }

    const isMobile = () => mobileMq.matches;
    const isOpen = () => root.classList.contains('is-open');

    const syncBodyLock = (open) => {
      document.body.classList.toggle('media-archive-tags-open', open && isMobile());
    };

    const setOpen = (open) => {
      root.classList.toggle('is-open', open);
      trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
      panel.hidden = !open;
      syncBodyLock(open);

      if (open && search) {
        search.focus();
      }
    };

    trigger.addEventListener('click', (event) => {
      event.stopPropagation();
      setOpen(!isOpen());
    });

    if (closeBtn) {
      closeBtn.addEventListener('click', (event) => {
        event.stopPropagation();
        setOpen(false);
        trigger.focus();
      });
    }

    // Desktop: close on outside click. Mobile fullscreen: close via X / Escape only.
    document.addEventListener('click', (event) => {
      if (!isOpen() || isMobile()) {
        return;
      }
      if (panel.contains(event.target) || trigger.contains(event.target)) {
        return;
      }
      setOpen(false);
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && isOpen()) {
        setOpen(false);
        trigger.focus();
      }
    });

    const onMobileChange = () => {
      if (isOpen()) {
        syncBodyLock(true);
      }
    };

    if (typeof mobileMq.addEventListener === 'function') {
      mobileMq.addEventListener('change', onMobileChange);
    } else if (typeof mobileMq.addListener === 'function') {
      mobileMq.addListener(onMobileChange);
    }

    if (search) {
      search.addEventListener('input', () => {
        const query = search.value.trim().toLowerCase();

        options.forEach((option) => {
          const text = (option.textContent || '').trim().toLowerCase();
          const match = query === '' || text.includes(query);
          const item = option.closest('li');
          if (item) {
            item.hidden = !match;
          }
        });
      });
    }
  });
});